var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alignments"},_vm._l((_vm.alignments),function(alignment,index){return _c('Alignment',{key:index,attrs:{"left":alignment[0],"right":alignment[1],"textSize":_vm.textSize,"textWidth":_vm.textWidth}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }